import React, { useEffect, useState } from 'react';
import { Table, Nav, NavItem, NavLink } from 'reactstrap';
import { toast } from 'react-toastify';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';
import ArrowDownIcon from 'mdi-react/ArrowDownIcon';
import Api from '../../../util/api';
import moment from 'moment';

import { partial } from '../../../util/translation/translation';

import Loading from '../../../shared/components/custom/Loading';
import Pagination from '../../../shared/components/pagination/Pagination';
import useConfig from '../../../util/useConfig';
import { formatCurrencyNumber } from '../../../util/functions';

const s = partial('shared');
const d = partial('Deals');

const CompaniesList = () => {
  const config = useConfig();
  const [loading, setLoading] = useState(false);
  const [deals, setDeals] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    currentPage: 1,
    perPage: 10,
  });
  const [order, setOrder] = useState({
    orderBy: 'value',
    desc: true,
  });
  const [startEndObject, setStartEndObject] = useState({
    start: null,
    end: null,
    type: 'allTime',
  });
  const handleStartEnd = (filter) => {
    let internal = {
      start: null,
      end: null,
      type: filter,
    };
    switch (filter) {
      case 'allTime':
        internal.start = null;
        internal.end = null;
        break;
      case 'thisYear':
        internal.start = moment().startOf('year').toISOString();
        internal.end = moment().endOf('year').toISOString();
        break;
      case 'lastYear':
        internal.start = moment()
          .subtract(1, 'year')
          .startOf('year')
          .toISOString();
        internal.end = moment().subtract(1, 'year').endOf('year').toISOString();
        break;
      default:
        internal.start = null;
        internal.end = null;
        break;
    }
    setStartEndObject(internal);
    getDeals(pagination.currentPage, pagination.perPage, order, internal);
  };
  const getDeals = async (
    currentPage = 1,
    pageSize = 10,
    orderObject = {
      orderBy: 'value',
      desc: true,
    },
    startEndObject = {
      start: null,
      end: null,
    }
  ) => {
    setLoading(true);
    try {
      const resDeals = await Api.companies.getCompanyDeals(
        { page: currentPage, take: pageSize },
        {
          orderBy: orderObject.orderBy,
          direction: orderObject.desc ? 'DESC' : 'ASC',
          startDate: startEndObject.start,
          endDate: startEndObject.end,
        }
      );
      setPagination((old) => ({ ...old, total: resDeals.count }));
      setDeals(resDeals.data);
      setLoading(false);
    } catch (err) {
      toast.error(JSON.stringify(err));
      setLoading(false);
    }
  };

  useEffect(() => {
    getDeals();
  }, []);

  const onChangePage = (pager) => {
    if (
      pager.pageSize !== pagination.perPage ||
      pager.currentPage !== pagination.currentPage
    ) {
      setPagination((old) => ({
        ...old,
        currentPage: pager.currentPage,
        perPage: pager.pageSize,
      }));
      getDeals(pager.currentPage, pager.pageSize, order);
    }
  };
  const handleSort = (incommingOrder) => {
    const newOrder = {
      orderBy: incommingOrder,
      desc: incommingOrder === order.orderBy ? !order.desc : true,
    };
    setOrder(newOrder);
    setPagination({
      total: 0,
      currentPage: 1,
      perPage: 10,
    });
    getDeals(1, 10, newOrder);
  };

  const listDeals = () => {
    return deals.map((deal, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`deal-${deal.companyName}`}
      >
        <td>{deal?.companyName}</td>
        <td>
          {formatCurrencyNumber(deal.value)} {config.currencyCaps}
        </td>
        <td>{deal.dealsCount}</td>
      </tr>
    ));
  };

  const renderSort = (cellOrder) => {
    if (order.orderBy !== cellOrder) {
      return undefined;
    }
    return order.desc ? <ArrowDownIcon size={16} /> : <ArrowUpIcon size={16} />;
  };

  return (
    <>
      <Loading loading={loading} />
      <Nav pills>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('allTime')}
            active={startEndObject.type === 'allTime'}
          >
            {s('allTime')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('thisYear')}
            active={startEndObject.type === 'thisYear'}
          >
            {s('thisYear')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('lastYear')}
            active={startEndObject.type === 'lastYear'}
          >
            {s('lastYear')}
          </NavLink>
        </NavItem>
      </Nav>

      <div
        style={{
          display: 'flex',
          marginTop: 10,
          paddingBottom: 5,
          background: '#fff',
          borderRadius: 6,
          boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
        }}
      >
        <Table responsive striped>
          <thead>
            <tr>
              <th>{s('company')}</th>
              <th
                style={{ color: '#4D576A' }}
                className="sortable"
                onClick={() => handleSort('value')}
              >
                <div className="flex alignItems-center">
                  {d('value')} {renderSort('value')}
                </div>
              </th>
              <th
                style={{ color: '#4D576A' }}
                className="sortable"
                onClick={() => handleSort('dealsCount')}
              >
                <div className="flex alignItems-center">
                  {d('activities')} {renderSort('dealsCount')}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>{listDeals()}</tbody>
        </Table>
      </div>
      <Pagination
        items={pagination.total}
        onChangePage={onChangePage}
        initialPage={pagination.currentPage}
      />
    </>
  );
};

export default CompaniesList;
